import { useState } from 'react';
import { SectionTitle, RunButton } from '../UI';

const MODELS = ['gpt-5.2-codex', 'gpt-5.2', 'gpt-5-mini', 'gpt-4.1', 'gpt-4.1-mini', 'gpt-4o', 'gpt-4o-mini'];

export default function SettingsTab({ config, authState, onSaveConfig }) {
  const [form, setForm] = useState({
    panel_name: config.panel_name || 'GEO Panel',
    default_model: config.default_model || 'gpt-5.2-codex',
    openai_api_key: '',
    report_brand_name: config.report_brand_name || config.panel_name || 'GEO Panel',
    report_author: config.report_author || 'OpenAI / Codex',
    report_footer_note: config.report_footer_note || 'Scores and recommendations are based on automated analysis and should be validated before publication.',
  });
  const [notice, setNotice] = useState('');

  async function handleSave() {
    await onSaveConfig(form);
    setForm((prev) => ({ ...prev, openai_api_key: '' }));
    setNotice('Settings saved.');
    setTimeout(() => setNotice(''), 2000);
  }

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: '700', marginBottom: '6px' }}>Settings</h1>
        <p style={{ fontSize: '14px', color: 'var(--text-3)' }}>
          Manage the OpenAI key, default model, and panel label for {authState.user?.username}.
        </p>
      </div>

      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '20px', display: 'grid', gap: '16px' }}>
        <SectionTitle>Application config</SectionTitle>
        <Field label="Panel name">
          <input value={form.panel_name} onChange={(e) => setForm((prev) => ({ ...prev, panel_name: e.target.value }))} style={inputStyle} />
        </Field>
        <Field label="Report brand name">
          <input value={form.report_brand_name} onChange={(e) => setForm((prev) => ({ ...prev, report_brand_name: e.target.value }))} style={inputStyle} placeholder="AdCrowd GEO Reports" />
        </Field>
        <Field label="Prepared by">
          <input value={form.report_author} onChange={(e) => setForm((prev) => ({ ...prev, report_author: e.target.value }))} style={inputStyle} placeholder="AdCrowd Strategy Team" />
        </Field>
        <Field label="Report footer note">
          <textarea value={form.report_footer_note} onChange={(e) => setForm((prev) => ({ ...prev, report_footer_note: e.target.value }))} style={{ ...inputStyle, minHeight: '88px', resize: 'vertical' }} />
        </Field>
        <Field label="Default model">
          <select value={form.default_model} onChange={(e) => setForm((prev) => ({ ...prev, default_model: e.target.value }))} style={inputStyle}>
            {MODELS.map((model) => <option key={model} value={model}>{model}</option>)}
          </select>
        </Field>
        <Field label={`OpenAI API key ${config.openai_api_key_set ? '(saved)' : '(missing)'}`}>
          <input type="password" value={form.openai_api_key} onChange={(e) => setForm((prev) => ({ ...prev, openai_api_key: e.target.value }))} style={inputStyle} placeholder={config.openai_api_key_set ? 'Leave blank to keep current key' : 'sk-...'} />
        </Field>
        {notice && <div style={{ color: 'var(--good)', fontFamily: 'var(--font-mono)', fontSize: '12px' }}>{notice}</div>}
        <RunButton onClick={handleSave}>Save Settings</RunButton>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'grid', gap: '8px' }}>
      <span style={{ fontSize: '11px', color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '1px', fontFamily: 'var(--font-mono)' }}>{label}</span>
      {children}
    </label>
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  background: 'var(--bg-surface)',
  border: '1px solid var(--border)',
  borderRadius: '10px',
  color: 'var(--text-1)',
  fontSize: '14px',
  outline: 'none',
};
